import type { TRefleksiDiskusiTindakLanjutValue } from 'types/kinerja-tim-penilai-ps'

export const PELAKSANAAN_PRAKTIK_KINERJA_PENDAMPINGAN_SURVEY_CRITERIAS = [
  'Pengawas Sekolah menunjukkan empati terhadap kondisi Anda dan/atau satuan pendidikan',
  'Pengawas Sekolah melakukan penyesuaian strategi pendampingan sesuai kondisi awal dan dinamika sepanjang pendampingan',
  'Pengawas Sekolah mengembangkan percakapan yang memberdayakan untuk peningkatan kinerja satuan pendidikan',
  'Pengawas Sekolah memberi umpan balik yang konstruktif selama melakukan pendampingan satuan pendidikan',
  'Pengawas Sekolah memberikan rekomendasi atau dukungan yang bermakna sesuai kondisi Kepala Sekolah dan/atau satuan pendidikan',
]

export const REFLEKSI_TINDAK_LANJUT_UPAYA_BELAJAR_OPTIONS: Record<
  TRefleksiDiskusiTindakLanjutValue,
  string
> = {
  MEET_EXPECTATION: 'Melakukan upaya tindak lanjut',
  EXCEED_EXPECTATION: 'Mempraktikkan inspirasi dari upaya tindak lanjut',
  EXCEPTIONAL:
    'Membagikan praktik baik hasil inspirasi dari upaya tindak lanjut',
}

export const REFLEKSI_TINDAK_LANJUT_UPAYA_REFLEKSI_OPTIONS: Record<
  TRefleksiDiskusiTindakLanjutValue,
  string
> = {
  MEET_EXPECTATION: 'Sadar tantangan dan penyebabnya ada di luar kendali diri',
  EXCEED_EXPECTATION:
    'Sadar tantangan dan penyebabnya ada di dalam kendali diri',
  EXCEPTIONAL:
    'Sadar tantangan dan penyebabnya ada di dalam kendali diri serta dampaknya',
}

export const REFLEKSI_TINDAK_LANJUT_PERUBAHAN_PRAKTIK_OPTIONS: Record<
  TRefleksiDiskusiTindakLanjutValue,
  string
> = {
  MEET_EXPECTATION: 'Ada upaya melakukan peningkatan kinerja',
  EXCEED_EXPECTATION:
    'Upaya melakukan peningkatan kinerja sejalan dengan ekspektasi atasan',
  EXCEPTIONAL:
    'Upaya melakukan peningkatan kinerja mendapat respon positif dari kepala sekolah',
}
